export default "__VITE_ASSET__860f8496__"